// ** Reducers Imports
import auth from './auth'
import airdrop from './airdrop'
import userCollectibles from './userCollectibles'

const rootReducer = { auth, airdrop, userCollectibles }

export default rootReducer
